import React from 'react';
import { Modal } from '@landr/maestro';
import { Widget } from '@typeform/embed-react';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';

var TypeformIds = {
  en: 'kV4VEl',
  fr: 'PlQHrS',
  de: 'duaTiX',
  it: 'cuJpfz',
  ja: 'V65erN',
  pt: 'oAqsJl',
  es: 'SDqMjh'
};
var FeedbackModal = function FeedbackModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
    onModalClose = _ref.onModalClose;
  var _useNavBarContext = useNavBarContext(),
    language = _useNavBarContext.language,
    user = _useNavBarContext.user;
  var typeformId = TypeformIds[language];
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isModalOpen,
    onClose: onModalClose
  }, /*#__PURE__*/React.createElement(Modal.Header, null), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Widget, {
    id: typeformId,
    style: {
      width: '100%',
      height: '510px'
    },
    hidden: {
      userId: (user === null || user === void 0 ? void 0 : user.userId) || '',
      email: (user === null || user === void 0 ? void 0 : user.email) || ''
    }
  })));
};

export { FeedbackModal };
